module.exports = __webpack_public_path__ + "img/uz.699ca9a0.svg";